<script setup>
import LabelValue from './LabelValue.vue'
import {addressTypeOptions} from '@/constants/address-types.js'

//Props
defineProps({
  type: {
    type: [String, Array],
    default: null,
  },
})
</script>

<template>
  <LabelValue
    :options="addressTypeOptions"
    :value="type"
    v-bind="$attrs"
  />
</template>
